module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "load-btn"
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-btn",
    attrs: {
      "disabled": _vm.upState == 'loading',
      "action": _vm.upUrl,
      "before-upload": _vm.prevCtrls,
      "on-progress": _vm.pgressCtrls,
      "on-error": _vm.errorCtrls,
      "on-success": _vm.successCtrls,
      "show-file-list": false,
      "data": _vm.fileData,
      "multiple": "",
      "limit": 3,
      "on-exceed": _vm.handleExceed
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.upState == 'loading',
      "size": "small"
    }
  }, [(_vm.upState == 'wait' || _vm.upState == 'loading') ? _c('span', [_vm._v("上传")]) : _vm._e(), _vm._v(" "), (_vm.upState == 'loaded') ? _c('span', [_vm._v("更新")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tips",
    staticStyle: {
      "margin-left": "12px"
    }
  }, [_vm._v("注：上传文件格式为JPEG/PNG，文件大小不超过10M")])], 1), _vm._v(" "), _c('div', {
    staticClass: "progressBox"
  }, [_c('el-progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upState == 'loading'),
      expression: "upState == 'loading'"
    }],
    attrs: {
      "stroke-width": 9,
      "percentage": _vm.percentage
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upState == 'loaded'),
      expression: "upState == 'loaded'"
    }],
    staticClass: "imgBox"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgUrl
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "edName uploadLine"
  }), _vm._v(" "), _c('div', {
    staticClass: "icons"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/left.png")
    },
    on: {
      "click": function($event) {
        _vm.handleLeftRotate(_vm.imgUrl)
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("@/assets/images/right.png")
    },
    on: {
      "click": function($event) {
        _vm.handleRightRotate(_vm.imgUrl)
      }
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.submitUpload
    }
  }, [_vm._v("保存")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.imgUrl,
      "alt": ""
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-117dcc15"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/upload.vue
// module id = 1681
// module chunks = 1